import type { Answers, DiscoveryContext, Question, Rule } from "./types";

export function evaluateRule(rule: Rule, answers: Answers): boolean {
  if ("equals" in rule) return answers[rule.field] === rule.equals;
  if ("includes" in rule) {
    const value = answers[rule.field];
    return Array.isArray(value) && value.includes(rule.includes);
  }
  if ("all" in rule) return rule.all.every((item) => evaluateRule(item, answers));
  if ("any" in rule) return rule.any.some((item) => evaluateRule(item, answers));
  return !evaluateRule(rule.not, answers);
}

export function questionApplies(
  question: Question,
  context: DiscoveryContext,
  answers: Answers,
): boolean {
  if (question.verticals && !question.verticals.includes(context.vertical)) return false;
  if (question.services && !question.services.includes(context.service)) return false;
  if (question.modes && !question.modes.includes(context.mode)) return false;
  if (question.visibleWhen && !evaluateRule(question.visibleWhen, answers)) return false;
  return true;
}
